import { useMutation, useQueryClient } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';
import { approvalQueueKeys } from './useApprovalQueue';
import { leaveKeys } from './useMijnVerlof';

/**
 * Story 7.7: de goedkeuring van de leidinggevende terugnemen (FR-30).
 *
 * Naar het model van `useDecideHrStap`, met dezelfde drie verversingen: de
 * aanvraag komt terug bovenaan de goedkeuringslijst, het eigen overzicht van
 * de aanvrager toont de nieuwe stand, en de aanwezigheidskalender laat de
 * afwezigheid weer los (AC-5) — precies zoals bij een afwijzing.
 */
export function useRetractApproval() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: number }) => verlofApi.retractApproval(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: approvalQueueKeys.all });
      queryClient.invalidateQueries({ queryKey: leaveKeys.all });
      queryClient.invalidateQueries({ queryKey: ['aanwezigheidskalender'] });
    },
  });
}
